import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

const BASE_API_URL = import.meta.env.VITE_BASE_API_URL || ''

export async function getAccessToken() {
  let accessToken = Cookies.get('accessToken') || localStorage.getItem('dev_access_token')

  if (import.meta.env.DEV) {
    Cookies.set('accessToken', accessToken ?? '', {
      expires: 1,
    })
  }

  const shouldRefreshToken = (() => {
    if (!accessToken) return true

    const { exp } = jwtDecode(accessToken)
    if (typeof exp !== 'number') return true

    return exp + 10 < new Date().getTime() / 1000
  })()

  const invalidateToken = () => {
    Cookies.remove('accessToken')
  }

  if (shouldRefreshToken) {
    try {
      const response = await fetch(`${BASE_API_URL}/users/me/token`, {
        method: 'POST',
        credentials: 'include',
      })

      if (response.ok) {
        const responseBody = await response.json()
        accessToken = responseBody.data.accessToken
        Cookies.set('accessToken', accessToken!)
      } else {
        invalidateToken()
      }
    } catch {
      invalidateToken()
    }
  }

  return accessToken
}

// @ts-ignore
window.getAccessToken = getAccessToken
